import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function CustomTabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ py: 3, px: 1 }}>{children}</Box>}
    </div>
  );
}

const AntTabs = styled(Tabs)(() => ({
  borderBottom: "1px solid #e8e8e8",
  width: "100%",
  display: "flex",
  "& .MuiTabs-indicator": {
    backgroundColor: "#1B2466",
  },
}));

const AntTab = styled((props) => <Tab disableRipple {...props} />)(() => ({
  textTransform: "none",
  flex: 1,
  width: "100%",
  height: "3.5rem",
  textAlign: "center",
  whiteSpace: "normal",
  wordBreak: "break-word",
  fontFamily: "Montserrat",
  fontSize: "15px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "1",
  color: "#1B2466",
  padding: "6px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textWrap: "wrap",
  transition: "color 0.3s ease-in-out, text-shadow 0.3s ease-in-out",
  "&:hover": {
    color: "#1B2466",
    textShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
    borderBottom: "2px solid #e8e8e8",
  },
  "&.Mui-selected": {
    color: "#1B2466",
    textAlign: "center",
    leadingTrim: "both",
    textEdge: "cap",
    fontFeatureSettings: "liga off, clig off",
    fontFamily: "Montserrat",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: "800",
    lineHeight: "128.571%",
  },
}));

// Modificamos el componente para aceptar value y onChange como props
export default function OptionsTab({ labels, children, value, onChange }) {
  // Si no se proporciona value y onChange, mantenemos el estado interno
  const [internalValue, setInternalValue] = useState(0);
  
  const handleChange = (event, newValue) => {
    if (onChange) {
      onChange(newValue);
    } else {
      setInternalValue(newValue);
    }
  };

  // Usamos el value proporcionado o el estado interno
  const tabValue = value !== undefined ? value : internalValue;

  return (
    <Box>
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "space-around" }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "clamp(320px, 90vw, 1544px)",
            margin: "auto",
          }}
        >
          <AntTabs 
            value={tabValue} 
            onChange={handleChange} 
            aria-label="tabs" 
            variant="fullWidth"
          >
            {labels.map((label, index) => (
              <AntTab
                key={index}
                label={label}
                id={`tab-${index}`}
                aria-controls={`tabpanel-${index}`}
              />
            ))}
          </AntTabs>

          {React.Children.toArray(children).map((child, index) => (
            <CustomTabPanel key={index} value={tabValue} index={index}>
              {child}
            </CustomTabPanel>
          ))}
        </Box>
      </Box>
    </Box>
  );
}